import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, Zap, Globe } from 'lucide-react';
interface PurchaseSectionProps {
  id?: string;
}
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  return <section id={id} className="scroll-mt-10" data-id="element-169">
      {/* Urgency strip */}
      <div className="bg-red-950/30 py-3 px-4 text-center border-y border-red-900/30" data-id="element-170">
        <p className="text-red-300 font-bold text-xs md:text-sm tracking-tight mb-1.5 uppercase" data-id="element-171">
          ⏰ El precio de lanzamiento termina en:
        </p>
        <CountdownTimer className="text-red-300 mb-1" data-id="element-172" />
        <p className="text-red-400/70 font-medium text-[10px] md:text-xs mt-1.5" data-id="element-173">
          Después sube el precio y no vuelve a bajar
        </p>
      </div>

      {/* Pricing */}
      <div className="py-6 md:py-8 px-4 bg-brand-dark" data-id="element-174">
        <div className="max-w-md mx-auto" data-id="element-175">
          <div className="bg-brand-card rounded-3xl border border-brand-accent/30 p-5 md:p-6 relative" data-id="element-176">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-brand-dark font-bold px-4 py-1.5 rounded-full text-[10px] md:text-xs tracking-wider whitespace-nowrap uppercase" data-id="element-177">
              🏆 OFERTA ÚNICA
            </div>

            <h3 className="text-lg md:text-xl font-extrabold text-white mb-1 mt-2 leading-tight text-center uppercase" data-id="element-178">
              Kit Completo Programación Técnica Lista
            </h3>
            <p className="text-brand-accent font-semibold text-xs md:text-sm mb-4 text-center" data-id="element-179">
              6 tomos + 4 bonos + Actualizaciones de por vida
            </p>

            {/* Value breakdown */}
            <div className="bg-brand-dark/60 rounded-2xl border border-white/5 p-4 mb-4" data-id="element-180">
              <p className="text-[11px] md:text-xs text-gray-400 font-semibold uppercase tracking-wider mb-3 text-center" data-id="element-181">
                Lo que recibís:
              </p>
              <div className="space-y-2 text-xs md:text-sm" data-id="element-182">
                <div className="flex justify-between items-center text-white" data-id="element-183">
                  <span data-id="element-184">📚 6 Tomos Maestros</span>
                  <span className="font-semibold text-gray-400" data-id="element-185">USD 222</span>
                </div>
                <div className="flex justify-between items-center text-white" data-id="element-186">
                  <span data-id="element-187">🎁 4 Bonos Estratégicos</span>
                  <span className="font-semibold text-gray-400" data-id="element-188">USD 46</span>
                </div>
                <div className="flex justify-between items-center text-white" data-id="element-189">
                  <span data-id="element-190">✅ Actualizaciones de por vida</span>
                  <span className="font-semibold text-gray-400" data-id="element-191">USD ∞</span>
                </div>
                <div className="border-t border-white/10 pt-2 mt-2 flex justify-between items-center" data-id="element-192">
                  <span className="text-gray-400 text-xs uppercase tracking-wider" data-id="element-193">
                    Valor total
                  </span>
                  <span className="font-bold text-white line-through" data-id="element-194">
                    USD 268
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mb-4" data-id="element-195">
              <p className="text-xs font-semibold text-brand-accent uppercase tracking-wider mb-1" data-id="element-196">
                🔥 Precio Hoy
              </p>
              <span className="text-5xl md:text-6xl font-extrabold text-white leading-none" data-id="element-197">
                USD 19,90
              </span>
              <p className="text-[10px] md:text-xs text-gray-500 mt-1" data-id="element-198">
                Pago único · Sin suscripciones
              </p>
            </div>

            <Button href="https://programacion.impultienda.ar/checkout" className="py-4 md:py-5 text-sm md:text-base w-full" pulse={true} data-id="element-199">
              🚀 → SÍ, QUIERO EL KIT COMPLETO
            </Button>

            {/* Trust below button */}
            <div className="grid grid-cols-2 gap-2 mt-4 text-[10px] md:text-xs" data-id="element-200">
              <div className="flex items-center gap-1.5 text-gray-300" data-id="element-201">
                <Lock className="w-3.5 h-3.5 text-brand-accent shrink-0" data-id="element-202" />
                <span className="font-medium" data-id="element-203">Pago seguro</span>
              </div>
              <div className="flex items-center gap-1.5 text-gray-300" data-id="element-204">
                <Zap className="w-3.5 h-3.5 text-brand-accent shrink-0" data-id="element-205" />
                <span className="font-medium" data-id="element-206">Acceso en 5 min</span>
              </div>
              <div className="flex items-center gap-1.5 text-gray-300" data-id="element-207">
                <Globe className="w-3.5 h-3.5 text-brand-accent shrink-0" data-id="element-208" />
                <span className="font-medium" data-id="element-209">En tu moneda</span>
              </div>
              <div className="flex items-center gap-1.5 text-gray-300" data-id="element-210">
                <ShieldCheck className="w-3.5 h-3.5 text-brand-accent shrink-0" data-id="element-211" />
                <span className="font-medium" data-id="element-212">Garantía 7 días</span>
              </div>
            </div>
          </div>

          {/* Currency disclaimer */}
          <div className="bg-brand-card/60 rounded-2xl border border-white/10 p-4 mt-4" data-id="element-213">
            <p className="text-xs md:text-sm text-gray-300 text-center font-normal leading-relaxed" data-id="element-214">
              El precio se muestra en{' '}
              <span className="text-white font-semibold" data-id="element-215">USD</span>. Al hacer
              clic, el sistema detecta tu país y te cobra automáticamente en tu
              moneda local — pesos argentinos, mexicanos, colombianos, soles
              peruanos, pesos chilenos o tu moneda nacional.{' '}
              <span className="text-white font-semibold" data-id="element-216">
                Sin sorpresas ni cargos ocultos.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}